<template>
	<div ref="anchor"></div>
</template>

<script>
import Plotly from 'plotly.js-dist-min'

export default {
	name: 'PlotlyPlot',

	props: {
		data: Object,
		layout: Object,
		onSliderUpdate: {
			type: Function,
			default: () => null,
		} 
	},

	watch: {
		data(newData, oldData) {
			const { $refs: { anchor }, layout } = this

			if(oldData){
				Plotly.react(anchor, newData, layout)
			}
		},
	},

	mounted () {
		const { $refs: { anchor }, data, layout, onSliderUpdate } = this

		Plotly.newPlot(anchor, data, layout)

		anchor.on('plotly_sliderchange', onSliderUpdate)
	},
}
</script>
